import * as z from "zod";

import { propertyPartSchema } from "./property-part";
import { propertySchema } from "./property";

export const propertyWithPartsSchema = propertySchema.extend({
  parts: z.preprocess(
    (value) => (Array.isArray(value) ? value : []),
    z.array(propertyPartSchema),
  ),
});

export type PropertyWithParts = z.infer<typeof propertyWithPartsSchema>;
